// extracted by mini-css-extract-plugin
module.exports = {"voteEntry":"Voting_voteEntry_3kKA7","voted":"Voting_voted_1Xy-R","select":"Voting_select_9t7eY","title":"Voting_title_3EwBG"};